import styled from "styled-components";

export const HeaderDropdownToggleLabel = styled("span")`
  position: relative;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  padding: 0 20px;
`;
